export default {"src":"/_next/static/media/emptyState.b4fb18cf.svg","height":166,"width":188,"blurWidth":0,"blurHeight":0};